import React from 'react';
// import { getLoggedUser } from '../../../../state/user';
import i18n from '../../../../i18n';
import { SideBar } from '../../sidebar';
import FilterSection from '../../../common/Filter';
import Dropdown from '../../../common/DropDown';
import NoData from '../../../common/NoData';
import { TableSkeleton } from '../../../common/skelton/TableSkelton';
import { tableStyles } from '../../../../styles/components/js/tableStyle';
import DataTable from 'react-data-table-component';
import { NavLink } from 'react-router-dom';
import { getGroupsList } from '../../../../models/groups';
import HeaderBanner from '../../../common/HeaderBanner';
import { getMyBids } from './services/myBidsServices';
import { formatDate } from '../../../../utils/common';
import { selectStyles } from '../../../../styles/components/js/selectStyle';
import Select from 'react-select';
import StatusBadge from '../../../common/StatusBadge';
import { AUCTION_STATUS } from '../../../../constants/status';

// const user = getLoggedUser();

export class MyBids extends React.Component {
  constructor() {
    super();
    this.state = {
      search: {
        startDate: null,
        endDate: null,
        status: '',
        group: null,
      },
      groups: [],
      myBids: [],
      isloading: false,
      limit: 15,
      page: 1,
      total: 0,
      groupLoading: false,
    };

    this.handleSearchChange = this.handleSearchChange.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    // Parse URL query params
    const params = new URLSearchParams(window.location.search);
    const search = {
      startDate: params.get('startDate') || null,
      endDate: params.get('endDate') || null,
      group: params.get('group') || null,
      status: params.get('status') || '',
    };
    const page = parseInt(params.get('page')) || 1;
    const limit = parseInt(params.get('limit')) || 15;

    this.setState({ search, page, limit }, () => {
      this.getAllGroups();
      this.myBids();
    });
  }

  // Update URL without refreshing page
  updateUrlQuery(q) {
    const queryString = new URLSearchParams(
      Object.fromEntries(Object.entries(q).filter(([_, v]) => v !== '' && v !== null))
    ).toString();
    window.history.replaceState(null, '', `${window.location.pathname}?${queryString}`);
  }
  async myBids() {
    this.setState({ isloading: true });
    let { limit, page } = this.state;
    let { startDate, endDate, group, status } = this.state.search;
    const q = {
      page: page,
      limit: limit,
    };

    if (startDate) q.startDate = startDate;
    if (endDate) q.endDate = endDate;
    if (group) q.group = group;
    if (status) q.status = status;

    // Update URL
    this.updateUrlQuery(q);

    let response = await getMyBids(q);
    if (response.success) {
      let myBids = response.data;
      let { total } = response.meta;

      this.setState({
        myBids,
        total,
        isloading: false,
      });
    }
    this.setState({ isloading: false });
  }

  async getAllGroups() {
    this.setState({ groupLoading: true });
    const response = await getGroupsList();
    if (response.success) {
      let data = response.data;
      const groups = data.map((item) => {
        return {
          value: item.id,
          label: item.group_name,
        };
      });
      this.setState({ groups });
      this.setState({ groupLoading: false });
    } else {
      this.setState({ groupLoading: false });
    }
  }

  getColumns = () => {
    const isArabic = i18n.language === 'ar';
    return [
      {
        name: 'Sl No',
        width: '90px',
        sortable: true,
        wrap: true,
        cell: (row, i) => i + 1,
      },
      {
        name: i18n.t('action'),
        width: '140px',
        wrap: true,
        center: true,
        cell: (row) => {
          const viewPath = `/auction-details/${row.id}`;
          const trackPath = `/track/${row.id}`;

          return (
            <div className="action-buttons">
              <ActionButton key="view" label="view" to={viewPath} />
              <ActionButton key="track" label="track" to={trackPath} />
            </div>
          );
        },
      },
      {
        name: 'ID',
        width: '110px',
        sortable: true,
        wrap: true,
        cell: (row) => <span className="highlight-table-value">MZAD {row.id}</span>,
      },
      {
        name: i18n.t('auction_name'),
        minWidth: '180px',
        cell: (row) => (
          <span className="highlight-table-value-secondary">
            {isArabic ? row.title_ar : row.title}
          </span>
        ),
      },
      {
        name: i18n.t('client'),
        minWidth: '150px',
        cell: (row) => (isArabic ? row.organization_name_ar : row.organization_name),
      },
      {
        name: i18n.t('end_date'),
        width: '120px',
        cell: (row) => <span className="highlight-table-value">{formatDate(row.end_date)}</span>,
        wrap: true,
      },
      {
        name: i18n.t('current_amount'),
        width: '130px',
        cell: (row) => <span className="highlight-table-value">{row.current_bid_amount}</span>,
        wrap: true,
        right: true,
      },
      {
        name: i18n.t('bid_amount'),
        width: '130px',
        cell: (row) => <span className="highlight-table-value">{row.bid_amount}</span>,
        wrap: true,
        right: true,
      },
      {
        name: i18n.t('previous_bid'),
        width: '120px',
        cell: (row) => (
          <span className="highlight-table-value">{row.previous_bid_amount || `--`}</span>
        ),
        wrap: true,
        center: true,
      },
      {
        name: i18n.t('bid_at'),
        width: '120px',
        cell: (row) => <span className="">{formatDate(row.last_bid_at)}</span>,

        wrap: true,
      },
      {
        name: i18n.t('total_bidders'),
        width: '120px',
        cell: (row) => row.total_bidders,
        wrap: true,
        center: true,
      },
      {
        name: i18n.t('rank'),
        width: '110px',
        cell: (row) => row.user_rank,
        wrap: true,
        center: true,
      },
      {
        name: i18n.t('status'),
        cell: (row) => <StatusBadge status={AUCTION_STATUS[row.status]} />,
        wrap: true,
      },
    ];
  };

  handleSearchChange = (e) => {
    const { name, value } = e.target;
    this.setState(
      (prevState) => {
        const updatedSearch = { ...prevState.search, [name]: value };
        return { search: updatedSearch };
      },
      () => {
        if (name === 'client') {
          this.getAllGroups();
        }
      }
    );
  };

  handleSearch = () => {
    this.myBids();
  };

  handleClear = () => {
    const defaultSearch = {
      startDate: null,
      endDate: null,
      status: '',
      group: null,
    };

    this.setState({ search: defaultSearch, page: 1, selectedRows: [] }, () => {
      this.myBids();
    });
  };

  onChangePage = (page) => {
    this.setState({ page: page }, () => {
      this.myBids();
    });
  };

  onChangeRowsPerPage = (limit) => {
    this.setState({ limit: limit, page: 1 }, () => {
      this.myBids();
    });
  };

  render() {
    const { groups, myBids } = this.state;

    return (
      <React.Fragment>
        <HeaderBanner title={i18n.t('my_bids')} subtitle={i18n.t('my_bid_info')} />
        <section className="dashboard-section">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? 'col-xl-12 col-lg-12 col-md-12'
                    : 'col-xl-9 col-lg-12 col-md-12'
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          });
                        }}
                      >
                        {this.state.hideSidebar && <i className="icon-size-actual"></i>}
                        {!this.state.hideSidebar && <i className="icon-size-fullscreen"></i>}
                      </span>
                    </div>
                  </div>
                  <div className="card-body">
                    <FilterSection
                      loading={this.state.isloading}
                      onSearch={this.handleSearch}
                      onClear={this.handleClear}
                    >
                      {/* Start Date */}
                      <div className="select-wrapper floating-label-wrapper">
                        <input
                          id="startDate"
                          type="date"
                          name="startDate"
                          value={this.state.search.startDate || ''}
                          onChange={this.handleSearchChange}
                          className="filter-base floating-input"
                          placeholder=" " // Important: single space for floating effect
                        />
                        <label htmlFor="startDate" className="floating-label">
                          {i18n.t('start_date')}
                        </label>
                      </div>

                      {/* End Date */}
                      <div className="select-wrapper floating-label-wrapper">
                        <input
                          id="endDate"
                          type="date"
                          name="endDate"
                          value={this.state.search.endDate || ''}
                          onChange={this.handleSearchChange}
                          className="filter-base floating-input"
                          placeholder={i18n.t('end_date')}
                        />
                        <label htmlFor="endDate" className="floating-label">
                          {i18n.t('end_date')}
                        </label>
                      </div>

                      {/* Status Type Dropdown */}
                      <Dropdown
                        name="status"
                        value={this.state.search.status}
                        onChange={this.handleSearchChange}
                        placeholder={i18n.t('status')}
                        empty={i18n.t('select_status')}
                        options={[
                          { value: 'A', label: i18n.t('active') },
                          { value: 'E', label: i18n.t('expired') },
                        ]}
                      />

                      {/* Bider Dropdown */}
                      <div className="react-select-wrapper">
                        <Select
                          options={groups}
                          value={groups.find((c) => c.value === this.state.search.group) || null}
                          onChange={(selectedOption) => {
                            this.setState((prevState) => ({
                              search: {
                                ...prevState.search,
                                group: selectedOption ? selectedOption.value : null,
                              },
                            }));
                          }}
                          name="group"
                          styles={selectStyles}
                          menuPlacement="auto"
                          menuPortalTarget={document.body}
                          placeholder={i18n.t('search_group')}
                          className=""
                        />
                        {/* Only show label when there's a selected value */}

                        <label className="react-select-label">{i18n.t('group')}</label>
                      </div>
                    </FilterSection>

                    <div className="Data-Listing">
                      {this.state.isloading ? (
                        <TableSkeleton columns={10} rows={10} />
                      ) : this.state.myBids.length ? (
                        <DataTable
                          responsive={true}
                          columns={this.getColumns()}
                          data={myBids}
                          customStyles={tableStyles}
                          highlightOnHover
                          pagination
                          paginationServer
                          paginationTotalRows={this.state.total}
                          paginationPerPage={this.state.limit}
                          paginationDefaultPage={this.state.page}
                          paginationRowsPerPageOptions={[15, 25, 50, 100]}
                          paginationComponentOptions={{
                            rowsPerPageText: i18n.t('rows_per_page'),
                            rangeSeparatorText: i18n.t('out'),
                          }}
                          onChangePage={this.onChangePage}
                          onChangeRowsPerPage={this.onChangeRowsPerPage}
                        />
                      ) : (
                        <NoData
                          message={i18n.t('no_auctions_available')}
                          actionText={i18n.t('refresh')}
                          onAction={this.myBids.bind(this)}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

const ActionButton = ({ label, icon, to, variant = 'info', onClick, active = false }) => {
  if (to) {
    return (
      <NavLink
        to={to}
        className={`btn-new`}
        style={{ whiteSpace: 'nowrap', cursor: 'pointer', marginRight: '4px' }}
      >
        {icon} {i18n.t(label)}
      </NavLink>
    );
  }

  return (
    <button
      disabled={active}
      className={`btn-new `}
      style={{ whiteSpace: 'nowrap', cursor: 'pointer', marginRight: '4px' }}
      onClick={onClick}
    >
      {icon} {i18n.t(label)}
    </button>
  );
};
